export enum InputTabNames {
	emoji = 'Emoji',
	mergeTag = 'Tags',
}

export const NOT_FOUND = {
	value: 'notFound',
	label: 'No results found.',
};
